const BRIDGE_HOSTNAME = "vmi2737685";
const VISITOR_COOKIE_NAME = "halaallove_visitor_id";
const VISITOR_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 400;
const SESSION_ID_STORAGE_KEY = "halaallove_bridge_session_id";
const EVENT_SEQ_STORAGE_KEY = "halaallove_bridge_event_seq";

function createVisitorId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return `visitor_${crypto.randomUUID()}`;
  }
  return `visitor_${Date.now()}_${Math.random().toString(36).slice(2, 12)}`;
}

function createSessionId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return `session_${crypto.randomUUID()}`;
  }
  return `session_${Date.now()}_${Math.random().toString(36).slice(2, 12)}`;
}

function getSessionStorageValue(key) {
  if (typeof window === "undefined" || !window.sessionStorage) return "";
  try {
    return window.sessionStorage.getItem(key) || "";
  } catch (err) {
    return "";
  }
}

function setSessionStorageValue(key, value) {
  if (typeof window === "undefined" || !window.sessionStorage) return;
  try {
    window.sessionStorage.setItem(key, value);
  } catch (err) {
    // Ignore browsers/storage modes that reject sessionStorage writes.
  }
}

function setCookieValue(name, value, maxAgeSeconds) {
  if (typeof document === "undefined") return;
  const secure = typeof window !== "undefined" && window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${name}=${encodeURIComponent(value)}; Max-Age=${maxAgeSeconds}; Path=/; SameSite=Lax${secure}`;
}

export function getOrCreateVisitorId() {
  const existing = getCookieValue(VISITOR_COOKIE_NAME);
  if (existing) return existing;
  const visitorId = createVisitorId();
  setCookieValue(VISITOR_COOKIE_NAME, visitorId, VISITOR_COOKIE_MAX_AGE_SECONDS);
  return visitorId;
}

export function getOrCreateSessionId() {
  const existing = getSessionStorageValue(SESSION_ID_STORAGE_KEY);
  if (existing) return existing;
  const sessionId = createSessionId();
  setSessionStorageValue(SESSION_ID_STORAGE_KEY, sessionId);
  return sessionId;
}

function getNextEventSeq() {
  const current = Number.parseInt(getSessionStorageValue(EVENT_SEQ_STORAGE_KEY) || "0", 10);
  const next = Number.isFinite(current) ? current + 1 : 1;
  setSessionStorageValue(EVENT_SEQ_STORAGE_KEY, String(next));
  return String(next);
}

function getCookieValue(name) {
  if (typeof document === "undefined") return "";
  const cookies = document.cookie ? document.cookie.split(";") : [];
  const prefix = `${name}=`;
  for (const cookie of cookies) {
    const trimmed = cookie.trim();
    if (trimmed.startsWith(prefix)) {
      return decodeURIComponent(trimmed.slice(prefix.length));
    }
  }
  return "";
}

function rot13(str) {
  return str.replace(/[a-zA-Z]/g, (char) => String.fromCharCode(
    (char <= "Z" ? 90 : 122) >= (char = char.charCodeAt(0) + 13) ? char : char - 26
  ));
}

function getStoredUserEmail() {
  if (typeof window === "undefined" || !window.localStorage) return "";
  try {
    const encoded = window.localStorage.getItem("userEmail");
    return encoded ? rot13(encoded) : "";
  } catch (err) {
    return "";
  }
}

function getBridgeActor() {
  return getCookieValue("email") || getStoredUserEmail();
}

/**
 * Fire-and-forget tracking ping matching the Vuna bridge style.
 * Uses an Image beacon so it is not blocked by CORS and does not delay UI actions.
 */
export function pingBridge(param) {
  if (typeof window === "undefined" || !param) return;
  new Image().src = `https://${BRIDGE_HOSTNAME}.contaboserver.net/bridge/?${param}`;
}

export function trackEvent(eventName, extraParams = {}) {
  if (!eventName) return;
  const params = new URLSearchParams({ [eventName]: "true" });
  const visitorId = getOrCreateVisitorId();
  if (visitorId && extraParams.visitor_id === undefined) {
    params.append("visitor_id", visitorId);
  }
  if (extraParams.session_id === undefined) {
    params.append("session_id", getOrCreateSessionId());
  }
  if (extraParams.event_seq === undefined) {
    params.append("event_seq", getNextEventSeq());
  }
  if (typeof window !== "undefined") {
    if (extraParams.host === undefined) params.append("host", window.location.hostname || "");
    if (extraParams.path === undefined) params.append("path", window.location.pathname || "");
  }
  if (extraParams.client_event_time === undefined) {
    params.append("client_event_time", new Date().toISOString());
  }
  const actor = getBridgeActor();
  if (actor && extraParams.user === undefined && extraParams.email === undefined) {
    params.append("user", actor);
  }
  Object.entries(extraParams).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      const normalizedValue = typeof value === "object" ? JSON.stringify(value) : String(value);
      params.append(key, normalizedValue);
    }
  });
  pingBridge(params.toString());
}
